// @ts-expect-error untyped import
import useUserInfo from '../../useUserInfo';
const useScopes = () => {
  const {
    data
  } = useUserInfo(false);
  return (data === null || data === void 0 ? void 0 : data.scopes) || [];
};
export default useScopes;